import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'participants'
})



export class Participants implements PipeTransform {

  filtrer(tickets) {
    let tmp = [];
    for( let i=0;i<tickets.length;i++) {
      if((tickets[i].order_id && tickets[i].order && tickets[i].order.state==1 && !tickets[i].statut ) || !tickets[i].order_id && !tickets[i].statut || new Date(tickets[i].created_at) <= new Date('2018-06-12') && !tickets[i].statut  )
      {
        tmp.push(tickets[i]);
      }
    }

    return tmp.length;
  }

  transform(tickets:any): any {
    return this.filtrer(tickets) ;
  }
}
